<div class="mb-2">
    <label class="form-label"></label>
    <input type="text" class="form-control">
</div>